import { ISelectValue } from 'constants/globalTypes'

export enum BreakPolicyScopeType {
  Company = 1,
  Site = 2,
}

export const breakPolicyScopeTypeOptions = [
  { value: BreakPolicyScopeType.Company, label: 'Company' },
  { value: BreakPolicyScopeType.Site, label: 'Site' },
]

export const breakPolicyAnchorTypeOptions = [
  { value: 1, label: 'Shift Start' },
  { value: 2, label: 'Shift End' },
]

export const breakPolicyPlacementStrategyOptions = [
  { value: 1, label: 'Earliest' },
  { value: 2, label: 'Latest' },
  { value: 3, label: 'Midpoint' },
]

export const breakPolicyEnforcementTypeOptions = [
  { value: 1, label: 'Hard' },
  { value: 2, label: 'Soft' },
]

export interface IBreakPolicyRoleRuleState {
  id?: number
  role: ISelectValue | null
  minimumActiveCount: number | null
}

export interface IBreakPolicyConstraintState {
  id?: number
  breakTemplateBreak: ISelectValue | null
  index: number
  anchorType: ISelectValue | null
  minOffsetMinutes: number | null
  maxOffsetMinutes: number | null
  placementStrategyType: ISelectValue | null
  durationOverrideMinutes: number | null
  enforcementType: ISelectValue | null
}

export interface IBreakPolicyState {
  id?: string
  breakTemplate: ISelectValue | null
  scopeType: ISelectValue
  siteNode: ISelectValue | null
  maxOnBreak: number | null
  minActive: number | null
  minGapBetweenBreaksInMinutes: number | null
  validFromDate: Date | null
  validToDate: Date | null
  roleRules: IBreakPolicyRoleRuleState[]
  constraints: IBreakPolicyConstraintState[]
}

export const emptyBreakPolicyState = (): IBreakPolicyState => ({
  breakTemplate: null,
  scopeType: { label: 'Company', value: BreakPolicyScopeType.Company },
  siteNode: null,
  maxOnBreak: null,
  minActive: null,
  minGapBetweenBreaksInMinutes: null,
  validFromDate: null,
  validToDate: null,
  roleRules: [{ role: null, minimumActiveCount: null }],
  constraints: [],
})
